window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.information = function (parent) {
    const _thisField = parent;
    let _control = null;

    {
        _thisField.settings.title = null;
    }

    const render = function (target) {
        _control = document.createElement('div');
        if (_thisField.settings.data.paragraph !== null) {
            _control.classList.add(window.mcb.forms.constants.fields.paragraphClass);
            _control.classList.add('mcb-content--rich'); // global target from core project
            _control.innerHTML = decodeURIComponent(_thisField.settings.data.paragraph);
            target.append(_control);
        }


        return _control;
    };

    const getValue = function (allowValueFormatting = false) {
        return undefined;
    };

    const setValue = function (value) {
        _control.value = value;
        return true;
    }

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
